var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLauncherIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 77,
    viewBox: "0 0 78 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_131_7365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4752 17.3783C18.0951 10.9151 23.5249 5.9812 30.0178 5.9812H51.5782C57.1815 5.9812 62.1116 9.68142 63.6768 15.0617L76.9102 60.5496C79.2557 68.6119 73.2081 76.6696 64.8116 76.6696H25.6547C18.2205 76.6696 12.4022 70.2666 13.1121 62.8663L17.4752 17.3783Z",
    fill: "#21E09D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.981 17.3783C11.601 10.9151 17.0308 5.9812 23.5237 5.9812H51.6215C57.7022 5.9812 62.9154 10.3238 64.0142 16.3044L72.3722 61.7923C73.7945 69.5336 67.8503 76.6696 59.9794 76.6696H19.1606C11.7263 76.6696 5.90811 70.2666 6.61792 62.8663L10.981 17.3783Z",
    fill: "#163564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.47337 17.4213C5.0892 10.9544 10.5206 6.01562 17.0168 6.01562H51.4408C58.0386 6.01562 63.5192 11.1053 64.0066 17.6851L67.3976 63.4691C67.9387 70.7746 62.1574 77 54.8318 77H12.6569C5.22609 77 -0.590988 70.6027 0.113447 63.2053L4.47337 17.4213Z",
    fill: "#1F529D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0902 52.7444L19.3643 41.6298L23.4549 37.4033L30.0902 44.2749L43.956 29.9066L48.0466 34.1455L30.0902 52.7444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.0705,
    cy: 14.5456,
    rx: 3.78824,
    ry: 3.8063,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.341,
    cy: 14.5456,
    rx: 3.78823,
    ry: 3.8063,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8504 6.05177C25.0102 7.88636 23.6943 10.7152 23.6943 14.6814C23.6943 15.5823 22.9674 16.3127 22.0708 16.3127C21.1741 16.3127 20.4473 15.5823 20.4473 14.6814C20.4473 9.94754 22.0402 6.2513 24.5633 3.73584C27.0701 1.23656 30.3996 -1.5557e-06 33.7061 0C37.0126 1.42606e-06 40.342 1.23657 42.8489 3.73585C45.372 6.25131 46.9649 9.94755 46.9649 14.6814C46.9649 15.5824 46.238 16.3127 45.3414 16.3127C44.4447 16.3127 43.7179 15.5824 43.7179 14.6814C43.7179 10.7152 42.402 7.88637 40.5618 6.05177C38.7054 4.201 36.2172 3.26254 33.7061 3.26254C31.1949 3.26254 28.7067 4.201 26.8504 6.05177Z",
    fill: "#21E09D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_131_7365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 77,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLauncherIcon);
export default __webpack_public_path__ + "static/media/launcherIcon.b22b9e2645da86c548cb4bc9d41295d7.svg";
export { ForwardRef as ReactComponent };